import * as navigation from 'Navigation';

export default class FormInstanceTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Form',
      closeable: false,
      preferenceKey: 'form-instance',
    };
  }
}
